import type { Optional } from '@vimeo/core/types/generic';

interface IJWTPayload {
  iss?: string;
  sub?: string;
  aud?: Array<string> | string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
}

export function parseJWT(token: string): Optional<IJWTPayload> {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    const payload = parts[1];
    const decoded = base64Decode(payload);
    return JSON.parse(decoded) as IJWTPayload;
  } catch {
    return null;
  }
}

// TODO add clock skew tolerance? or do it at the tokenservice level?
export function getTimeUntilExpiration(token: string): Optional<number> {
  const payload = parseJWT(token);
  if (!payload || !payload.exp) {
    return null;
  }
  const now = Math.floor(Date.now() / 1000);
  const timeUntilExpiration = (payload.exp - now) * 1000;
  return Math.max(0, timeUntilExpiration);
}

function base64Decode(str: string): string {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw new Error('base64 string is not of the correct length');
  }
  try {
    return decodeURIComponent(
      atob(output).replace(/(.)/g, (_, p) => {
        let code = (p as string).charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
          code = '0' + code;
        }
        return '%' + code;
      }),
    );
  } catch {
    return atob(output);
  }
}
